import type * as api from '@gitbook/api-client';
import type { IconName as FAIconName } from '@gitbook/icons';
import { Icon } from '@gitbook/spine-icons';

import { ContentIcon } from '../Icons';

export function SiteExternalLinkIcon(props: {
    siteExternalLink: api.SiteExternalLink;
    size?: number;
    className?: string;
}) {
    const { siteExternalLink, ...iconProps } = props;
    if (!siteExternalLink.icon) {
        return <Icon.Link {...iconProps} />;
    }

    return <ContentIcon icon={siteExternalLink.icon as FAIconName} {...iconProps} />;
}
